"use client"

import { AccountLockup } from "@opensea/app-kit"
import type { FragmentOf } from "@opensea/graphql"
import { readFragment } from "@opensea/graphql"
import type { AddressDisplay } from "@opensea/ui-kit"
import { useAddress } from "@/hooks/wallet"
import { ProfilePreviewTooltip } from "../profile/ProfilePreviewTooltip/ProfilePreviewTooltip"
import { ActivityFromFragment } from "./ActivityFrom.fragment"

type Props = {
  activity: FragmentOf<typeof ActivityFromFragment>
  display?: AddressDisplay
  className?: string
  showDisplayName?: boolean
}

export function ActivityFrom({
  activity: activityKey,
  display = "compact",
  className,
  showDisplayName = true,
}: Props) {
  const activity = readFragment(ActivityFromFragment, activityKey)
  const connectedAddress = useAddress()

  return (
    <ProfilePreviewTooltip profile={activity.from}>
      <AccountLockup
        account={activity.from}
        addressDisplay={display}
        className={className}
        connectedAddress={connectedAddress ?? null}
        disableTextOverflowTooltip
        showDisplayName={showDisplayName}
      />
    </ProfilePreviewTooltip>
  )
}
